import {UserProfileType} from '../lib/auth.service';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {AppNgbTimeStruct} from './ngb-datepicker';
import {Models} from './model-utils';
import {DisabledEnum, SearchUtils} from './search-utils';
import {MultiselectOptionItem, MultiselectOptionItemWithData} from './core-utils';
import {HistoryBaseModel} from '../admin/history-log/history-log/history-log.component';
import {LdapData, UserHistoryType} from '../lib/user.service';

export class UserBaseModel {
  externalId: string | null;
  types: UserProfileType[] = [];
  userName: string = '';
  password: string = '';
  personName: string = '';
  profilePicture?: string;
  selectedProfilePicture: string | null | undefined;
  emailAddress: string = '';
  phoneNumber: string = '';
  userGroups: MultiselectOptionItem<number>[] = [];
  defaultAssigneeUserGroups: MultiselectOptionItem<number>[] = [];
  allowedDevices: MultiselectOptionItem<number>[] = [];
  inactivationDate: NgbDateStruct | null = null;
  inactivationTime: AppNgbTimeStruct = Models.zeroNgbTime();
  driver: DriverCreateModel = new DriverCreateModel();
  isDriver: boolean = false;
  hasSignature: boolean = false;
  vehicle: MultiselectOptionItem<number>[] = [];
  isProtected: boolean = false;
  color: number = 0;
  isHelpdesk: boolean = false;

  // Helpdesk
  contactPerson: MultiselectOptionItemWithData<number>[] = [];
  contactLocations: MultiselectOptionItem<number>[] = [];
  customerRecord: MultiselectOptionItemWithData<number>[] = [];

  ldap?: LdapData;

  public createUserGroupIds(): number[] {
    return this.userGroups.map(ug => ug.id);
  }

  public createDefaultAssigneeUserGroupIds(): number[] | undefined {
    if (this.defaultAssigneeUserGroups.length === 0) {
      return undefined;
    }
    return this.defaultAssigneeUserGroups.map(ug => ug.id);
  }

  get vehicleId(): number | undefined {
    return this.vehicle.length > 0 ? this.vehicle[0].id : undefined;
  }

}

export class DriverCreateModel {
  medicalExpiryDate: NgbDateStruct | null = null;
  permissionExpiryDate: NgbDateStruct | null = null;
  drivingLicenceNumber: string = '';
  drivingLicenceCategories: string = '';
  drivingLicenceExpiryDate: NgbDateStruct | null = null;
}

export class UserGroupItemForDropdown extends MultiselectOptionItem<number> {
  companyIds?: number[];
}

export enum LdapFeature {
  EMAIL,
  PHONE_NUMBER,
  NFC_CARD
}

export class UserSearchModel extends SearchUtils.SearchModel {
  id: string = '';
  username: string = '';
  personName: string = '';
  externalId: string = '';
  emailAddress: string = '';
  disabled: DisabledEnum = DisabledEnum.FALSE;
  companies: MultiselectOptionItem<number>[] = [];
  isDriver: boolean = false;
  userGroups: MultiselectOptionItem<number>[] = [];
  defaultAssigneeGroups: MultiselectOptionItem<number>[] = [];
  type: UserTypeFilterOption = 'ALL';

  public isEmpty(): boolean {
    return this.id.length === 0
      && this.username.length === 0
      && this.personName.length === 0
      && this.externalId.length === 0
      && this.emailAddress.length === 0
      && this.companies.length === 0
      && this.userGroups.length === 0
      && this.defaultAssigneeGroups.length === 0
      && !this.isDriver
      && this.disabled === DisabledEnum.FALSE
      && this.type === 'ALL'
      ;
  }
}

export type UserTypeFilterOption = 'ALL' | 'USER' | 'LDAP';

export class UserTypeFilterOptionsObject {
  type: UserTypeFilterOption;
  stringKey: string;
}

export const userTypeFilterOptions: UserTypeFilterOptionsObject[] = [
  {type: 'ALL', stringKey: 'COMMON_VALUE_ALL'},
  {type: 'USER', stringKey: 'LOGIN_METHOD_NAME_LOCAL_USER'},
  {type: 'LDAP', stringKey: 'LOGIN_METHOD_NAME_LDAP_USER'},
];

export class UserHistoryModel extends HistoryBaseModel {
  type: UserHistoryType;
}
